import type { VersionDeltasView } from '../api.js';

/**
 * What moved since each schedule's or estimate's prior version (ADR-0077, gate D0-D2), and, reused
 * under its own heading, where two documents disagree (D8). On the Hub's project page beside the
 * gate's questions.
 *
 * ⚠️ Its own file, not in `AnalysisView`: the Hub bundle must not reach the analyzer pages (R9,
 * `HubApp.bundle.test.ts`).
 *
 * ⚠️ LINES ONLY. The questions are in the gate list directly above (`check: 'version-delta'` and
 * `'cross-document'`), so listing them here too said each one twice (red-team, A2-4). This panel is
 * every movement and every "could not compare" line, so nothing compared is left unsaid.
 *
 * Neutral styling, whatever moved: all of it is report only.
 */
export function VersionDeltasPanel({
  deltas,
  title = 'Since the last version',
}: {
  deltas: readonly VersionDeltasView[];
  /** The panel's heading. The cross-document checks (ADR-0077 D8) reuse it under their own. */
  title?: string;
}) {
  const lines = deltas.flatMap((d) => d.lines);
  if (lines.length === 0) return null;
  return (
    <section className="notice reconcile">
      <strong>{title}</strong>
      <ul className="reconcile__prose">
        {lines.map((l, i) => (
          <li key={`${String(i)}:${l.summary}`}>{l.summary}</li>
        ))}
      </ul>
    </section>
  );
}
